import { DEFAULT_PAGE_SIZE } from '@w7/ui'
import { ApiError, hasLiveApi } from '@/api/client'
import { getBlockedIps, toBlockedIpResult } from '@/api/map/blockedIps'
import type { BlockedIpQuery, BlockedIpResult } from './blockedIpTypes'

/** Empty page when demo / offline — no invented blocked-IP rows. */
export function emptyBlockedIps(query: BlockedIpQuery = {}): BlockedIpResult {
  const pageSize = Math.max(1, query.pageSize ?? DEFAULT_PAGE_SIZE)
  const page = Math.max(1, query.page ?? 1)
  return {
    rows: [],
    total: 0,
    page,
    pageSize,
  }
}

/**
 * Live Keycloak → hierarchy `getBlockedIps`.
 * Demo / no live API → empty (never invent blocked-IP rows).
 */
export async function loadBlockedIps(
  query: BlockedIpQuery = {},
): Promise<BlockedIpResult> {
  if (!hasLiveApi()) return emptyBlockedIps(query)

  try {
    const live = await getBlockedIps({
      page: query.page ?? 1,
      pageSize: query.pageSize ?? DEFAULT_PAGE_SIZE,
      ip: query.ip,
      player: query.player,
    })
    if (!live.value) return emptyBlockedIps(query)
    return toBlockedIpResult(live, query)
  } catch (err) {
    const status = err instanceof ApiError ? err.status : 0
    console.warn('[blocked-ips] hierarchy getBlockedIps unavailable', err)
    if (status === 404) {
      console.warn(
        '[blocked-ips] Agent-API blockedIp/getBlockedIps route is not deployed on this hierarchy yet.',
      )
    }
    return emptyBlockedIps(query)
  }
}
